import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PagerModule } from '@mhe/ngx-shared/pager';
import { TranslateModule, TranslateService } from '@mhe/ngx-shared/translate';
import { DataTableChildComponent } from './child.component';
import { DataTableDynamicContentsDirective } from './dynamic/dynamic.contents.directive';
import { DataTableHeaderButtonComponent } from './header-button.component';
import { LocalFilterPipe } from './localfilter.pipe';
import { AriaNotifierComponent } from './notifier/aria-notifier.component';
import { DataTableBodyComponent } from './table.body.component';
import { DataTableCellComponent } from './table.cell.component';
import { DataTableComponent } from './table.component';
import { DataTableFooterComponent } from './table.footer.component';
import { DataTableHeaderComponent } from './table.header.component';
import { DataTableInfoHeaderComponent } from './table.info.header.component';
import { DataTableUtils } from './table.utils';
import * as i0 from "@angular/core";
export class DataTableModule {
}
DataTableModule.ɵfac = function DataTableModule_Factory(t) { return new (t || DataTableModule)(); };
DataTableModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DataTableModule });
DataTableModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [DataTableUtils, TranslateService], imports: [CommonModule, FormsModule, PagerModule, RouterModule, TranslateModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, PagerModule, RouterModule, TranslateModule],
                declarations: [
                    AriaNotifierComponent,
                    DataTableComponent,
                    DataTableChildComponent,
                    DataTableDynamicContentsDirective,
                    DataTableCellComponent,
                    DataTableHeaderComponent,
                    DataTableHeaderButtonComponent,
                    DataTableInfoHeaderComponent,
                    DataTableFooterComponent,
                    DataTableBodyComponent,
                    LocalFilterPipe,
                ],
                exports: [DataTableComponent],
                providers: [DataTableUtils, TranslateService],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DataTableModule, { declarations: [AriaNotifierComponent,
        DataTableComponent,
        DataTableChildComponent,
        DataTableDynamicContentsDirective,
        DataTableCellComponent,
        DataTableHeaderComponent,
        DataTableHeaderButtonComponent,
        DataTableInfoHeaderComponent,
        DataTableFooterComponent,
        DataTableBodyComponent,
        LocalFilterPipe], imports: [CommonModule, FormsModule, PagerModule, RouterModule, TranslateModule], exports: [DataTableComponent] }); })();
